import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[autofocus]',
})
export class AutoFocus implements AfterViewInit {
    constructor(private elementRef: ElementRef<HTMLElement>) {}

    ngAfterViewInit(): void {
        const element = this.elementRef.nativeElement;

        if (this.requiresProgrammaticFocusability(element)) {
            element.tabIndex = -1;
    }
        element.focus();
    }

    private requiresProgrammaticFocusability(element: HTMLElement): boolean {
        return element.tabIndex < 0 && !this.isNativelyFocusable(element);
    }

    private isNativelyFocusable(element: HTMLElement): boolean {
        const tagName = element.tagName.toLowerCase();

        if (element.hasAttribute('contenteditable')) {
            return true;
        }

        if (tagName === 'a' || tagName === 'area') {
            return element.hasAttribute('href');
        }

        return ['button', 'input', 'select', 'textarea', 'iframe'].includes(tagName);
    }
}
